import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';

const HreflangTags = () => {
  const location = useLocation();
  const { language } = useLanguage();

  useEffect(() => {
    // Remove existing hreflang tags
    const existingTags = document.querySelectorAll('link[hreflang]');
    existingTags.forEach(tag => tag.remove());

    // Get base URL (in production, this would be the actual domain)
    const baseUrl = window.location.origin;
    
    // Determine the path without language prefix
    let basePath = location.pathname;
    if (basePath.startsWith('/en/')) {
      basePath = basePath.replace('/en', '');
    } else if (basePath === '/en') {
      basePath = '/';
    }

    // Create French URL
    const frUrl = `${baseUrl}${basePath}`;
    
    // Create English URL
    const enUrl = basePath === '/' 
      ? `${baseUrl}/en` 
      : `${baseUrl}/en${basePath}`;

    // Add hreflang tags
    const frTag = document.createElement('link');
    frTag.rel = 'alternate';
    frTag.hreflang = 'fr';
    frTag.href = frUrl;
    document.head.appendChild(frTag);

    const enTag = document.createElement('link');
    enTag.rel = 'alternate';
    enTag.hreflang = 'en';
    enTag.href = enUrl;
    document.head.appendChild(enTag);

    // Add x-default (pointing to French as default)
    const defaultTag = document.createElement('link');
    defaultTag.rel = 'alternate';
    defaultTag.hreflang = 'x-default';
    defaultTag.href = frUrl;
    document.head.appendChild(defaultTag);

    return () => {
      // Cleanup on unmount
      const tags = document.querySelectorAll('link[hreflang]');
      tags.forEach(tag => tag.remove());
    };
  }, [location.pathname, language]);

  return null;
};

export default HreflangTags;
